var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShows = function SvgShows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.804 1.461H4.131a.697.697 0 0 0 0 1.392h7.976v7.976a.697.697 0 0 0 1.393 0V2.157a.696.696 0 0 0-.696-.696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.065 5.198h-7.87a.697.697 0 0 0-.695.696v7.872c0 .384.312.696.696.696h7.87a.697.697 0 0 0 .695-.696V5.894a.695.695 0 0 0-.696-.696"
  })));
};
export default SvgShows;